<app-spinner [visible]="visibleSpinner"></app-spinner>
<app-mensajes
  [code]="code"
  [titulo]="titulo"
  [detalle]="detalle"
  [sw]="sw"
></app-mensajes>
<div class="p-col-12">
  <div class="p-grid">
    <div class="p-col-12">
      <p-card>
        <div class="p-col-12">
          <button
            pButton
            type="button"
            label="Nueva Solicitud"
            icon="pi pi-plus"
            class="ui-button-info"
            style="float: right"
            (click)="goToPage('/inicio')"
          ></button>
        </div>
        <div class="p-col-8">
          <h3>MIS SOLICITUDES</h3>
        </div>
        <div class="p-col-12">
          <div class="p-col-12" class="container-search">
            <div class="p-fluid p-grid p-formgrid">
              <div class="p-col-1" style="margin-top: 5px; text-align: center">
                Filtrar por:
              </div>
              <div class="p-col-3">
                <span class="p-input-icon-left" style="width: 100%">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    pInputText
                    placeholder="Número de solicitud"
                    [(ngModel)]="numeroSolicitud"
                    style="width: 100%"
                    class="p-inputtext-sm"
                    (keyup.enter)="filter()"
                  />
                </span>
              </div>
              <div class="p-col-3">
                <span class="p-input-icon-left" style="width: 100%">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    pInputText
                    placeholder="Nombre del proceso"
                    [(ngModel)]="nombreProceso"
                    style="width: 100%"
                    class="p-inputtext-sm"
                    (keyup.enter)="filter()"
                  />
                </span>
              </div>
              <div class="p-col-3">
                <span class="p-input-icon-left" style="width: 100%">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    pInputText
                    placeholder="Contenido"
                    [(ngModel)]="contenidoSolicitud"
                    style="width: 100%"
                    (keyup.enter)="filter()"
                    class="p-inputtext-sm"
                  />
                </span>
              </div>
              <div class="p-col-2">
                <button
                  pButton
                  type="button"
                  label="Filtrar"
                  [disabled]="searching"
                  icon="pi pi-search"
                  class="p-button-sm ui-button-info"
                  (click)="filter()"
                ></button>
              </div>
            </div>
          </div>
          <p-table
            #dt
            [value]="solicitudes"
            [paginator]="true"
            [showCurrentPageReport]="true"
            [lazy]="true"
            (onLazyLoad)="getSolicitudesEvent($event)"
            [totalRecords]="totalRecords"
            currentPageReportTemplate="Mostrando registros del {first} al {last} de un total de {totalRecords} registros"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 30]"
            sortField="created_at"
            sortOrder="-1"
            [scrollable]="true"
            scrollHeight="{{ scroll }}px"
          >
            <!-- let-"type" para consumir datos -->

            <ng-template pTemplate="header" let-columns>
              <tr class="d-info-table">
                <th class="fix">
                  Número de solicitud
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal">
                  Nombre del proceso
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal">
                  Estado de la solicitud
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="date">
                  Creación
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="date">
                  Recepción
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal" *ngIf="estado === 'observadas'">
                  Última fecha para subsanar
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal">
                  Detalle 1
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal">
                  Detalle 2
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th class="normal">
                  Detalle 3
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
              </tr>
            </ng-template>
            <!-- let-"type" para consumir datos -->
            <ng-template pTemplate="body" let-solicitud>
              <tr class="d-info-table">
                <th class="fix" style="text-align: center">
                  <div>
                    <button
                      pButton
                      type="button"
                      (click)="
                        getURL(
                          solicitud.version_proceso.codigo_proceso,
                          solicitud.id
                        )
                      "
                      [icon]="solicitud.editable ? 'pi pi-pencil' : 'pi pi-eye'"
                      class="alinear-buttons p-button-sm p-button-rounded d-button-edit"
                      [pTooltip]="
                        solicitud.editable ? 'Editar solicitud' : 'Ver solicitud'
                      "
                    ></button>
                    <button
                      pButton
                      type="button"
                      [icon]="'fa fa-calendar'"
                      class="alinear-buttons p-button-sm p-button-rounded d-button-save"
                      *ngIf="
                        solicitud.estado.codigo_estado_proceso ===
                          'OBSERVACION.FONDO' && !solicitud.prorroga
                      "
                      pTooltip="Solicitar prórroga"
                      tooltipPosition="left"
                      (click)="
                        showModal(solicitud.id, solicitud.numero_solicitud, 2)
                      "
                    ></button>
                    <button
                      pButton
                      type="button"
                      (click)="
                        historialModal(solicitud.id, solicitud.numero_solicitud)
                      "
                      class="alinear-buttons p-button-sm p-button-rounded d-button-second"
                      pTooltip="Historial de la solicitud"
                      [icon]="'pi pi-info-circle'"
                    ></button>
                    <button
                      *ngIf="!(
                      solicitud.estado.codigo_estado_proceso === 'SOLICITUD.DESISTIMIENTO.INTERNA' ||
                      solicitud.estado.codigo_estado_proceso === 'SOLICITUD.DESISTIMIENTO' ||
                      solicitud.estado.codigo_estado_proceso === 'NUEVA.SOLICITUD' ||
                      solicitud.estado.codigo_estado_proceso === 'FIN.TRAMITE.LISTO' ||
                      solicitud.estado.codigo_estado_proceso === 'FIN.TRAMITE.TRAMITE'
                      )"
                      pButton
                      type="button"
                      [icon]="'fa fa-level-down'"
                      class="alinear-buttons p-button-sm p-button-rounded d-button-delete"
                      pTooltip="Desistir"
                      tooltipPosition="left"
                      (click)="
                        showModal(solicitud.id, solicitud.numero_solicitud, 1)
                      "
                    ></button>
                    <button
                      pButton
                      type="button"
                      [icon]="'fa fa-trash'"
                      class="alinear-buttons p-button-sm p-button-rounded d-button-delete "
                      *ngIf="
                        solicitud.estado.codigo_estado_proceso === 'BORRADOR' ||
                        solicitud.estado.codigo_estado_proceso ===
                          'NUEVA.SOLICITUD'
                      "
                      pTooltip="Eliminar"
                      tooltipPosition="left"
                      (click)="
                        showModal(solicitud.id, solicitud.numero_solicitud, 3)
                      "
                    ></button>
                    <button
                      *ngIf="(solicitud.estado.codigo_estado_proceso === 'FIN.TRAMITE.TRAMITE' ||
                      solicitud.estado.codigo_estado_proceso === 'FIN.TRAMITE.LISTO')"
                      pButton
                      type="button"
                      [icon]="'fa fa-download'"
                      class="alinear-buttons p-button-sm p-button-rounded p-button-success"
                      pTooltip="Descargar resolución"
                      tooltipPosition="left"
                      (click)="
                      descargarDocumentoResolucion(solicitud.resoluciones.documento_resolucion)
                      "
                    ></button>
                  </div>
                  &nbsp; &nbsp;
                 {{ solicitud.numero_solicitud }}
                </th>
                <td class="normal">
                  {{ solicitud.version_proceso.nombre_proceso }}
                </td>
                <td class="normal">
                  {{ solicitud.estado.nombre_estado_externo }}
                </td>
                <td class="date">
                  {{ solicitud.created_at | date: "dd-MM-yyyy" }}
                </td>
                <td class="date">
                  {{
                    solicitud.fecha_recepcion
                      ? (solicitud.fecha_recepcion | date: "dd-MM-yyyy")
                      : "-"
                  }}
                </td>
                <td class="normal" *ngIf="estado === 'observadas'">
                  <i
                    class="fa fa-circle"
                    aria-hidden="true"
                    style="color: {{ solicitud.semaforo }}"
                  >
                  </i
                  >&nbsp;
                  <ng-container *ngIf="solicitud.fecha_maxima">
                    {{
                      solicitud.fecha_maxima + " " + solicitud.semaforo_text
                    }}</ng-container
                  >
                  <ng-container *ngIf="!solicitud.fecha_maxima"
                    >Calculando <i class="pi pi-spin pi-spinner"></i
                  ></ng-container>

                  <br />
                  <div *ngIf="solicitud.prorroga > 0">
                    PRÓRROGA:
                    <strong>{{
                      getNombreEstadoProrroga(solicitud)
                    }}</strong>&nbsp;
                    <button
                      pButton
                      type="button"
                      (click)="prorrogaModal(solicitud)"
                      class="p-button-link"
                      [label]="' '"
                      pTooltip="Información de la prórroga"
                      [icon]="'pi pi-info-circle'"
                      style="margin: 0; padding: 0"
                    ></button>
                  </div>
                </td>
                <td class="normal">
                  <div
                    [innerHTML]="
                      solicitud?.detalles[0] ? solicitud.detalles[0] : '--'
                    "
                  ></div>
                  <div
                    [innerHTML]="
                      solicitud?.detalles[3] ? solicitud.detalles[3] : ''
                    "
                  ></div>
                </td>
                <td class="normal">
                  <div
                    [innerHTML]="
                      solicitud?.detalles[1] ? solicitud.detalles[1] : '--'
                    "
                  ></div>
                  <div
                    [innerHTML]="
                      solicitud?.detalles[4] ? solicitud.detalles[4] : ''
                    "
                  ></div>
                </td>
                <td class="normal">
                  <div
                    [innerHTML]="
                      solicitud?.detalles[2] ? solicitud.detalles[2] : '--'
                    "
                  ></div>
                  <div
                    [innerHTML]="
                      solicitud?.detalles[5] ? solicitud.detalles[5] : ''
                    "
                  ></div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">No se encontraron resultados.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>
      <p-dialog
        [header]="headermodal"
        [(visible)]="displayModal"
        [modal]="true"
      >
        <div *ngIf="tipo === 1">
          <div class="p-col-12">
            Esta por desistir de la solicitud número
            <strong>{{ numero }}</strong
            >, está seguro de querer realizar esta acción?
          </div>
          <div class="p-col-12">
            <label>Motivo por el cual esta desistiendo a la solicitud:</label>
          </div>
          <div class="p-col-12">
            <textarea
              rows="7"
              cols="30"
              pInputTextarea
              [(ngModel)]="nota"
              style="width: 100%"
            ></textarea>
          </div>
          <div class="p-col-12 button-container" style="text-align: center">
            <button
              style="margin: auto"
              class="p-button"
              pButton
              icon="fa fa-check"
              type="submit"
              label="ENVIAR"
              (click)="guardarDesistimiento()"
            ></button
            >&nbsp;&nbsp;
            <button
              style="margin: auto"
              class="p-button-danger"
              pButton
              icon="fa fa-times"
              type="button"
              label="Cancelar"
              (click)="CancelarDesistimiento()"
            ></button>
          </div>
        </div>
        <div *ngIf="tipo === 2">
          <form (ngSubmit)="storeprorroga()">
            <div class="p-col-12">
              Esta por solicitar prórroga de la solicitud número
              <strong>{{ numero }}</strong>
            </div>
            <div class="p-col-12">
              <label>
                Motivo por el que solicita la prórroga.<br/>
                <b *ngIf="archivoObligatorio; else noObligatorio" style="color: red;">(Adjuntar documento, campo obligatorio):</b>
                <ng-template #noObligatorio>
                  <b>(Adjuntar documento, campo no obligatorio):</b>
                </ng-template>
              </label>
            </div>
            <div class="p-col-12">
              <div class="ui-inputgroup">
                <p-fileUpload
                  #fileUpload
                  id="dui_archivo"
                  mode="basic"
                  [customUpload]="true"
                  name="demo[]"
                  (onSelect)="archivo($event)"
                  chooseLabel="Seleccionar archivo"
                  (uploadHandler)="limpiarArchivo(fileUpload)"
                ></p-fileUpload>
              </div>
            </div>
            <div class="p-col-12 button-container" style="text-align: center">
              <button
                style="margin: auto"
                class="p-button"
                pButton
                icon="fa fa-check"
                type="submit"
                label="Aceptar"
              ></button
              >&nbsp;&nbsp;
              <button
                style="margin: auto"
                class="p-button-danger"
                pButton
                icon="fa fa-times"
                type="button"
                label="Cancelar"
                (click)="CancelarDesistimiento()"
              ></button>
            </div>
          </form>
        </div>
        <div *ngIf="tipo === 3">
          <form (ngSubmit)="EliminarSolicitud()">
            <div>
              <label>
                Está por eliminar la solicitud número <strong>{{ numero }}</strong>.
              </label>
            </div>
            <div>
              <label><br>Al eliminar la solicitud, ya no se encontrará disponible y el mandamiento de pago ya no podrá utilizarse en ninguna otra solicitud.<br><br>Esta acción es irreversible, ¿Desea continuar?</label>
            </div>
            <br>
            <div style="text-align: center;">
             <input type="checkbox" id="aceptarCondiciones" (click)="aceptarCondiciones()"/> <label for="aceptarCondiciones">Estoy de acuerdo</label>
            </div>
            <br />
            <div class="p-col-12 button-container" style="text-align: center">
              <button
                style="margin: auto"
                class="p-button"
                pButton
                icon="fa fa-check"
                type="submit"
                label="Aceptar"
                [disabled]="aceptar"
              ></button
              >&nbsp;&nbsp;
              <button
                style="margin: auto"
                class="p-button-danger"
                pButton
                icon="fa fa-times"
                type="button"
                label="Cancelar"
                (click)="CancelarDesistimiento()"
              ></button>
            </div>
          </form>
        </div>
      </p-dialog>
      <p-confirmDialog
        [style]="{ width: '50vw' }"
        [baseZIndex]="10000"
        rejectButtonStyleClass="p-button-text"
        acceptLabel="SI"
        rejectLabel="NO"
      ></p-confirmDialog>
    </div>
  </div>
</div>

<p-dialog [header]="title" [style]="view" [(visible)]="showMe" [modal]="true">
  <app-historial-solicitud
    (visual)="spinner($event)"
    [id]="id"
  ></app-historial-solicitud>
</p-dialog>

<p-dialog [header]="title" [style]="view" [(visible)]="showPr" [modal]="true">
  <div style="padding: 1em">
    Número de solicitud: <b>{{ prorroga.numero_solicitud || "--" }}</b
    ><br />
    Estado: <b>{{ prorroga.estado || "--" }}</b
    ><br />
    <ng-container *ngIf="prorroga.estado != 'TRÁMITE'"
      >Fecha de revisión:
      <b>{{ prorroga.fecha_revision || "Pendiente de revisión" }}</b
      ><br
    /></ng-container>
    <ng-container *ngIf="prorroga.estado == 'APROBADA' || prorroga.estado == 'VISTO BUENO EN TRÁMITE'"
      >Cantidad de días aprobados:
      <b>{{ prorroga.plazo || "Pendiente de revisión" }}</b
      ><br />
      Nueva fecha máxima de subsanación:
      <b>{{ prorroga.fecha_prorroga || "Pendiente de revisión" }}</b
      ><br
    /></ng-container>
    <ng-container *ngIf="prorroga.estado == 'RECHAZADA'">
      Comentarios: {{ prorroga.comentarios || "--" }}</ng-container
    >
  </div>
</p-dialog>
